// import React, { useState } from "react";
// import styled from "styled-components";
// import { projects } from "../../data/constants";
// import ProjectCard from "../cards/ProjectCard";

// const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-contnet: center;
//   margin-top: 50px;
//   padding: 0px 16px;
//   position: rlative;
//   z-index: 1;
//   align-items: center;
// `;

// const Wrapper = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-direction: column;
//   width: 100%;
//   max-width: 1100px;
//   gap: 12px;
//   @media (max-width: 960px) {
//     flex-direction: column;
//   }
// `;
// const Title = styled.div`
//   font-size: 52px;
//   text-align: center;
//   font-weight: 600;
//   margin-top: 20px;
//   color: ${({ theme }) => theme.text_primary};
//   @media (max-width: 768px) {
//     margin-top: 12px;
//     font-size: 32px;
//   }
// `;
// const Desc = styled.div`
//   font-size: 18px;
//   text-align: center;
//   font-weight: 600;
//   color: ${({ theme }) => theme.text_secondary};
//   @media (max-width: 768px) {
//     font-size: 16px;
//   }
// `;

// const ToggleButtonGroup = styled.div`
//   display: flex;
//   border: 1.5px solid ${({ theme }) => theme.primary};
//   color: ${({ theme }) => theme.primary};
//   font-size: 16px;
//   border-radius: 12px;
// font-weight 500;
// margin: 22px 0;
// @media (max-width: 768px){
//     font-size: 12px;
// }
// `;
// const ToggleButton = styled.div`
//   padding: 8px 18px;
//   border-radius: 6px;
//   cursor: pointer;
//   &:hover {
//     background: ${({ theme }) => theme.primary + 20};
//   }
//   @media (max-width: 768px) {
//     padding: 6px 8px;
//     border-radius: 4px;
//   }
//   ${({ $active, theme }) =>
//     $active &&
//     `
//   background:  ${theme.primary + 20};
//   `}
// `;
// const Divider = styled.div`
//   width: 1.5px;
//   background: ${({ theme }) => theme.primary};
// `;

// const CardContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 28px;
//   flex-wrap: wrap;
// `;

// const Projects = () => {
//   const [toggle, setToggle] = useState("all");
//   return (
//     <Container id="Projects">
//       <Wrapper>
//         <Title>Projects</Title>
//         <Desc
//           style={{
//             marginBottom: "40px",
//           }}
//         >
//           I have worked on a wide range of projects. From web apps to android
//           apps. Here are some of my projects.
//         </Desc>

//         <ToggleButtonGroup>
//           <ToggleButton
//             active={toggle === "all"}
//             onClick={() => setToggle("all")}
//           >
//             ALL
//           </ToggleButton>
//           <Divider />
//           <ToggleButton
//             active={toggle === "web app"}
//             onClick={() => setToggle("web app")}
//           >
//             WEB APP"S
//           </ToggleButton>
//           <Divider />
//           <ToggleButton
//             active={toggle === "android app"}
//             onClick={() => setToggle("android app")}
//           >
//             ANDROID APP'S
//           </ToggleButton>
//           <Divider />
//           <ToggleButton
//             active={toggle === "machine learning"}
//             onClick={() => setToggle("machine learning")}
//           >
//             MACHINE LEARNING
//           </ToggleButton>
//         </ToggleButtonGroup>

//         <CardContainer>
//           {toggle === "all" &&
//             projects.map((project) => <ProjectCard key={project.id} project={project} />)}
//           {projects
//             .filter((item) => item.category === toggle)
//             .map((project) => (
//               <ProjectCard project={project} />
//             ))}
//         </CardContainer>
//       </Wrapper>
//     </Container>
//   );
// };

// export default Projects;



import React, { useState, useMemo } from "react";
import styled from "styled-components";
import { projects } from "../../data/constants";
import ProjectCard from "../cards/ProjectCard";

/* ==================== Styled Components ==================== */

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 80px;
  padding: 0 16px;
  position: relative;
  z-index: 1;
  align-items: center;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Title = styled.h2`
  font-size: 48px;
  text-align: center;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const Desc = styled.p`
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  max-width: 700px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ToggleButtonGroup = styled.div`
  display: flex;
  border: 1.5px solid ${({ theme }) => theme.primary};
  border-radius: 12px;
  margin: 30px 0;
  overflow: hidden;
`;

const ToggleButton = styled.button`
  padding: 10px 20px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.primary};
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.primary + "20"};
  }

  ${({ $active, theme }) =>
    $active &&
    `
      background: ${theme.primary + "20"};
      font-weight: 600;
    `}
`;

const CardContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 28px;
  flex-wrap: wrap;
`;

/* ==================== Component ==================== */

const categories = [
  "all",
  "web app",
  "android app",
  "machine learning",
];

const Projects = () => {
  const [toggle, setToggle] = useState("all");

  // Optimized filtering using useMemo
  const filteredProjects = useMemo(() => {
    if (toggle === "all") return projects;
    return projects.filter((item) => item.category === toggle);
  }, [toggle]);

  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>

        <Desc>
          I have worked on a wide range of projects — from web applications to
          Android apps and Machine Learning solutions.
        </Desc>

        <ToggleButtonGroup>
          {categories.map((category) => (
            <ToggleButton
              key={category}
              $active={toggle === category}
              onClick={() => setToggle(category)}
            >
              {category.toUpperCase()}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        <CardContainer>
          {filteredProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;